import getEnvConfig from "@efcloud/el-b2b-get-env-config"
import deepmerge from "deepmerge"

export default deepmerge({
  myPage: "/campus/mypage/home",
  enrollment: "/enrollment",
  GAPEnrollment: "/gap/ui/onboarding"
}, getEnvConfig("pathsConfig"))
